module.exports = __webpack_public_path__ + "assets/0c1bd7d5805c2b0718b55b3b6042bea3.png";